<div class="pane warning">
	<h2 class="title"><i class="fa fa-{{icon}}"></i> {{title}} </h2>

	<div *ngIf="!templateRef" class="contents" [innerHTML]="contents"></div>

	<div class="contents" *ngIf="templateRef">
		<ng-container *ngTemplateOutlet="templateRef"></ng-container>
	</div>
	
	<div class="buttons right">
		<div class="button margin" [ngClass]="{'disabled': confirmed}" (click)="cancel()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</div>
		<div *ngIf="!showSave" class="button margin submit" [ngClass]="{'disabled': confirmed}" (click)="confirm()"><i class="fa fa-{{icon}}"></i> {{ 'CONFIRM' | translate }}</div>
		<div *ngIf="showSave" class="button margin" [ngClass]="{'disabled': confirmed}" (click)="confirm()"><i class="fa fa-save"></i> {{ 'DONT_SAVE' | translate }}</div>
		<div *ngIf="showSave" class="button margin submit" [ngClass]="{'disabled': confirmed}" (click)="saveAndClose()"><i class="fa fa-save"></i> {{ 'SAVE' | translate }}</div>
	</div>

</div>
